import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deleteSuperAdminUser } from '@actions/superAdminUsers/deleteSuperAdminUser';
import {
    getSuperAdminUserIsPosting,
    getSuperAdminUserPostSuccess,
    getSuperAdminUsersPostError,
} from '@selectors/superAdminUsers';

export default function useDeleteSuperAdmin(userID: number): UseDeleteSuperAdminReturn {
    const dispatch = useDispatch();

    const deleteUser = useCallback(() => {
        dispatch(deleteSuperAdminUser(userID));
    }, [dispatch, userID]);

    const isPosting = useSelector(getSuperAdminUserIsPosting);
    const error = useSelector(getSuperAdminUsersPostError);
    const deleteSuccess = useSelector(getSuperAdminUserPostSuccess);

    return {
        deleteUser,
        isPosting,
        error,
        deleteSuccess,
    };
}

interface UseDeleteSuperAdminReturn {
    deleteUser: () => void;
    isPosting: boolean;
    error: string | null;
    deleteSuccess: boolean;
}
